/**
 * Model (Contextual Model) - The semantic authority within a Bounded Context.
 *
 * A Model's semantic layer is simply an OntologyBinding — the BC's own ontology.
 * The OntologyBinding provides namespace configuration and ontology schemas.
 *
 * Core invariant: Models define layers; layers do not define models.
 */
/**
 * Default implementation of Model for runtime use.
 */
export class ModelImpl {
    constructor(params) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_semanticLayerBinding", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_constraintLayer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = params.id;
        this.name = params.name;
        this._semanticLayerBinding = params.semanticLayerBinding ?? null;
    }
    getSemanticLayerBinding() {
        return this._semanticLayerBinding ?? undefined;
    }
    getConstraintLayer() {
        return this._constraintLayer;
    }
    /**
     * Set the semantic layer binding for this model.
     */
    setSemanticLayerBinding(binding) {
        this._semanticLayerBinding = binding;
    }
    /**
     * Serialize to JSON-LD with per-object @context.
     */
    toJSON() {
        return {
            '@context': {
                '@vocab': 'http://semantical.io/ontology/core#'
            },
            '@type': 'Model',
            '@id': `urn:semantical:model:${this.id}`,
            name: this.name
        };
    }
}
